import React, { useState } from 'react';
import EventGroupsPicker from '../EventGroupsPicker';

const ChooseGroups = props => {
	const { event, eventID, handleSetGroupIDs, groupIDs } = props;
	const [targetKeys, setTargetKeys] = useState([]);
	const isControlled = groupIDs !== undefined;
	const keys = isControlled ? groupIDs : targetKeys;

	const handleChange = (direction, ids) => {
		const rightIDs = ids.rightIDs.map(id => parseInt(id));
		if (!isControlled) setTargetKeys(rightIDs);
		handleSetGroupIDs(rightIDs);
	};

	return (
		<EventGroupsPicker
			event={event}
			eventID={eventID}
			targetKeys={keys}
			handleChange={handleChange}
		/>
	);
};

export default ChooseGroups;
